<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '100vw', maxWidth: '90vw' }"
  [header]="'Ask Me Anything'"
  (onHide)="hideDialog()"
  styleClass="chat-dialog">

  <div class="chat-container">
    <!-- Messages Area -->
    <div class="messages-container" #scrollContainer>
      <div class="messages-list">
        <div
          *ngFor="let message of messages"
          class="message-item"
          [ngClass]="message.isUser ? 'user-message' : 'bot-message'">

          <div class="message-content">
            <div class="message-avatar">
              <p-avatar
                [image]="message.isUser ? (user?.profileImageUrl || 'assets/images/default-profile.png') : undefined"
                [label]="message.isUser ? undefined : 'G'"
                [styleClass]="message.isUser ? '' : 'bot-avatar'"
                size="normal"
                shape="circle" />
            </div>

            <div class="message-bubble">
              <div class="message-text" [innerHTML]="message.content"></div>
              <div class="message-time">
                {{ message.timestamp | date:'shortTime' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Loading indicator -->
        <div *ngIf="isLoading" class="message-item bot-message">
          <div class="message-content">
            <div class="message-avatar">
              <p-avatar
                label="G"
                styleClass="bot-avatar"
                size="normal"
                shape="circle" />
            </div>
            <div class="message-bubble">
              <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Input Area -->
    <div class="input-container">
      <div class="input-wrapper">
        <p-iconField iconPosition="right">
          <p-inputIcon
            styleClass="pi pi-send"
            (click)="sendMessage()"
            [class.disabled]="!newMessage.trim() || isLoading" />
          <input
            type="text"
            pInputText
            [(ngModel)]="newMessage"
            placeholder="Type your message..."
            class="message-input"
            (keypress)="onKeyPress($event)"
            [disabled]="isLoading"
            #messageInput />
        </p-iconField>
      </div>
    </div>
  </div>
</p-dialog>
